export function BrowserChromeIcon() {
  return (
    <svg
      preserveAspectRatio="none"
      overflow="visible"
      style={{ display: 'block' }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Chrome</title>
      <g id="browser-chrome-colour" clipPath="url(#clip0_0_1175)">
        <path
          id="Vector"
          d="M7.99975 11.9991C10.2089 11.9991 11.9997 10.2083 11.9997 7.99914C11.9997 5.78999 10.2089 3.99914 7.99975 3.99914C5.7906 3.99914 3.99975 5.78999 3.99975 7.99914C3.99975 10.2083 5.7906 11.9991 7.99975 11.9991Z"
          fill="white"
        />
        <path
          id="Vector_2"
          d="M4.53564 10L1.0721 4.00099C0.369806 5.21699 4.84521e-05 6.59647 5.07937e-09 8.00071C-4.84419e-05 9.40495 0.369615 10.7845 1.07182 12.0005C1.77403 13.2166 2.78403 14.2263 4.00025 14.9282C5.21648 15.6301 6.59606 15.9994 8.00031 15.9991L11.4638 10V9.99898C11.113 10.6073 10.6082 11.1126 10.0002 11.4639C9.39213 11.8152 8.7023 12.0002 8.00005 12.0003C7.2978 12.0004 6.6079 11.8156 5.99975 11.4645C5.39162 11.1133 4.88663 10.6083 4.53564 10Z"
          fill="url(#paint0_linear_0_1175)"
        />
        <path
          id="Vector_3"
          d="M11.4636 9.99977L8.00008 15.9988C9.40432 15.999 10.7838 15.6295 12 14.9274C13.2161 14.2253 14.226 13.2154 14.928 11.9993C15.63 10.7831 15.9995 9.40356 15.9993 7.99931C15.999 6.59507 15.6291 5.21567 14.9266 3.99975H7.99949L7.99863 4.00028C8.70088 3.99992 9.39083 4.18451 9.99911 4.53542C10.6074 4.88635 11.1125 5.39124 11.4637 5.99936C11.815 6.60747 11.9998 7.29735 11.9998 7.99957C11.9998 8.70182 11.8148 9.39167 11.4636 9.99977Z"
          fill="url(#paint1_linear_0_1175)"
        />
        <path
          id="Vector_4"
          d="M7.99975 11.1667C9.74865 11.1667 11.1664 9.7489 11.1664 8C11.1664 6.2511 9.74865 4.83332 7.99975 4.83332C6.25084 4.83332 4.83309 6.2511 4.83309 8C4.83309 9.7489 6.25084 11.1667 7.99975 11.1667Z"
          fill="#1A73E8"
        />
        <path
          id="Vector_5"
          d="M7.99977 4H14.9269C14.2249 2.7838 13.2151 1.77383 11.999 1.07167C10.783 0.369514 9.40343 -9.96444e-05 7.99919 2.03175e-08C6.59495 9.96851e-05 5.21549 0.369907 3.99952 1.07224C2.78352 1.77457 1.77389 2.78469 1.07211 4.00097L4.53564 10L4.53653 10.0005C4.18512 9.39248 3.99997 8.70271 3.99975 8.00046C3.99952 7.29821 4.18423 6.60828 4.53526 6.00008C4.88627 5.39187 5.39129 4.88681 5.99944 4.53572C6.60762 4.18461 7.29752 3.99985 7.99977 4Z"
          fill="url(#paint2_linear_0_1175)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_0_1175"
          x1="8.8657"
          y1="15.4994"
          x2="1.93835"
          y2="3.50088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E8E3E" />
          <stop offset="1" stopColor="#34A853" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_0_1175"
          x1="6.83284"
          y1="16.02"
          x2="13.7602"
          y2="4.02146"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCC934" />
          <stop offset="1" stopColor="#FBBC04" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_0_1175"
          x1="1.07211"
          y1="5.00023"
          x2="14.9269"
          y2="5.00023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D93025" />
          <stop offset="1" stopColor="#EA4335" />
        </linearGradient>
        <clipPath id="clip0_0_1175">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
